module.exports = __webpack_public_path__ + "static/media/macbook-air.2f6694c6.png";